export default "__VITE_ASSET__DYrsvDRl__"